import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LandingService } from '../../services/Landing_Services/landing.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;
  captchaImage = signal<string | null>(null);
  captchaHash = signal<string | null>(null);
  captchaExpires = signal<number | null>(null);
  isSubmitting = signal<boolean>(false);
  submitError = signal<string | null>(null);
  submitSuccess = signal<string | null>(null);

  constructor(
    private fb: FormBuilder,
    private landingService: LandingService
  ) {
    this.contactForm = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      company: [''],
      subject: ['', Validators.required],
      message: ['', Validators.required],
      captchaText: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.refreshCaptcha();
  }

  refreshCaptcha(): void {
    this.landingService.getCaptcha().subscribe({
      next: (data) => {
        this.captchaImage.set(data.image);
        this.captchaHash.set(data.hash);
        this.captchaExpires.set(data.expires);
        this.contactForm.patchValue({ captchaText: '' });
      },
      error: (error) => {
        console.error('Error loading CAPTCHA:', error);
        this.submitError.set('Failed to load CAPTCHA. Please try again.');
      }
    });
  }

  onSubmit(): void {
    this.submitError.set(null);
    this.submitSuccess.set(null);

    const hash = this.captchaHash();
    const expires = this.captchaExpires();

    if (this.contactForm.invalid || !hash || (expires && Date.now() > expires)) {
      this.contactForm.markAllAsTouched();
      if (!hash || (expires && Date.now() > expires)) {
        this.submitError.set('CAPTCHA expired or invalid. Please refresh.');
        this.refreshCaptcha();
      }
      return;
    }

    this.isSubmitting.set(true);
    const formData = {
      ...this.contactForm.value,
      captchaHash: hash,
    };

    this.landingService.createContact(formData).subscribe({
      next: (response) => {
        this.submitSuccess.set('Message sent successfully!');
        this.contactForm.reset();
        this.refreshCaptcha();
        this.isSubmitting.set(false);
      },
      error: (error) => {
        const message = error.error?.message || 'Failed to send message. Please try again.';
        this.submitError.set(message);
        if (message === 'Invalid captcha') {
          this.refreshCaptcha();
        }
        this.isSubmitting.set(false);
      },
    });
  }
}
